module.exports = __webpack_public_path__ + "timeline-onboarding-cn@2x.cd9d2f12.png";


//////////////////
// WEBPACK FOOTER
// ./src/template/Docks/StudentInfo/Timeline/images/timeline-onboarding-cn@2x.png
// module id = 7GlU
// module chunks = 0